import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Dropdown, Card } from 'react-bootstrap';
import { Bell } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';

const NavbarNotification = () => {
  const dispatch = useDispatch();
  const notification = useSelector(state => state.common.notification);
  const notificationStatus = useSelector(state => state.common.status);
  const [notificationData, setNotificationData] = useState([]);
  const isNotificationBedge = useSelector(state => state.common.isNotificationBedge);
  const maxNotification = 10;
  useEffect(() => {
    if (notificationStatus === 'idle') {
      dispatch(fetchNotification());
    }
  }, [notificationStatus, dispatch]);
  useEffect(() => {
    if (notification && Object.keys(notification).length > 0) {
      if (notification.error === 0) {
        setNotificationData(notification.data.client_notifications);
      }
    }
  }, [notification]);
  return (
    <Dropdown
      className='nav-item'
      align='end'
      onClick={() => {
        dispatch(setNotifcationBedge(false));
      }}>
      <style>
        {`

        a.dropdown-item span {
            font-size: 14px;
            font-weight: 300;   
        }
        a.dropdown-item > small {
            font-size: 12px;
            font-weight: 300;
            color: var(--bs-light-gray) !important;
        }
            @keyframes sonar {
            0% {
                transform: scale(0.5);
                opacity: 1;
            }
            100% {
                transform: scale(2);
                opacity: 0;
            }
            }

                    .sonar-dot {
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: red;
            border-radius: 50%;
            position: absolute;
            top: 0;
            right: 0;
            top: 19px;
            left: 23px;
                animation: sonar 1.5s infinite;
            }
        `}
      </style>
      <span className='d-none d-sm-inline-block'>
        <Dropdown.Toggle as='a' className='nav-link caret-off'>
          <Bell />
        </Dropdown.Toggle>
        {isNotificationBedge && <span className='sonar-dot'></span>}
      </span>
      <Dropdown.Menu drop='end' className='p-0'>
        <Card className='mb-0 shadow p-3'>
          {notificationData && notificationData.length > 0 ? (
            <>
              {notificationData.map((data, index) => {
                return (
                  index <= maxNotification && (
                      <Link key={index} to={`/all-notification/${index}`} className='text-decoration-none text-black dropdown-item'>
                      <span className='text-capitalize'>
                        {data.notification_text.slice(0, 40)}
                        {data.notification_text.length > 40 ? '...' : ''}
                      </span>
                      <br />
                      <small>{moment(data.created_on).fromNow()}</small>
                      </Link>
                  )
                );
              })}
              {notificationData.length >= maxNotification && (
                <Dropdown.Item>
                  {' '}
                  <Link to='/all-notification' className='text-decoration-none'>
                    Show More
                  </Link>
                </Dropdown.Item>
              )}
            </>
          ) : (
            <Dropdown.Item>No New Notification</Dropdown.Item>
          )}
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarNotification;
